export default items => items.filter((_, index) => index < 10);
